import React, { useState } from "react";
import { IconButton, Popover, Box, Typography, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

const CollectionInfoPopover = ({ selectedCollections, collectionFilesMap }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  if (!selectedCollections || selectedCollections.length === 0) return null;

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);

  return (
    <>
      <Tooltip title="View selected collections">
        <IconButton
          onClick={handleOpen}
          sx={{
            color: "#FFC629",
            padding: "6px",
            "&:hover": { backgroundColor: "rgba(255,198,41,0.1)" },
          }}
        >
          <InfoOutlinedIcon />
        </IconButton>
      </Tooltip>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            backgroundColor: "#1a1a1a",
            border: "1px solid rgba(255,198,41,0.2)",
            borderRadius: "12px",
            maxWidth: 360,
            maxHeight: 420,
            overflowY: "auto",
            mt: 1,
            scrollbarWidth: "thin",
            scrollbarColor: "rgba(255,255,255,0.08) transparent",
            "&::-webkit-scrollbar": { width: "4px" },
            "&::-webkit-scrollbar-thumb": {
              background: "rgba(255,255,255,0.08)",
              borderRadius: "2px",
            },
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography
            sx={{
              color: "#FFC629",
              fontFamily: "Raleway, sans-serif",
              fontWeight: "bold",
              fontSize: "1rem",
              mb: 1.5,
            }}
          >
            Selected Collections
          </Typography>

          {selectedCollections.map((collection) => {
            const files = collectionFilesMap[collection.id] || [];
            return (
              <Box key={collection.id} sx={{ mb: 2, "&:last-child": { mb: 0 } }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                  <FolderOutlinedIcon
                    sx={{ color: "#FFC629", fontSize: "1.1rem" }}
                  />
                  <Typography
                    sx={{
                      color: "#fff",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 600,
                      fontSize: "0.9rem",
                    }}
                  >
                    {collection.name}
                  </Typography>
                </Box>

                <Box sx={{ pl: 3.5 }}>
                  {files.length === 0 ? (
                    <Typography
                      sx={{
                        color: "rgba(255,255,255,0.4)",
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "0.8rem",
                        fontStyle: "italic",
                      }}
                    >
                      No documents
                    </Typography>
                  ) : (
                    files.map((file) => (
                      <Box
                        key={file.FileID}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.75,
                          py: 0.3,
                        }}
                      >
                        <DescriptionOutlinedIcon
                          sx={{
                            color: "rgba(255,255,255,0.5)",
                            fontSize: "0.85rem",
                          }}
                        />
                        <Typography
                          sx={{
                            color: "rgba(255,255,255,0.75)",
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "0.8rem",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: 260,
                          }}
                          title={file.FileName}
                        >
                          {file.FileName}
                        </Typography>
                      </Box>
                    ))
                  )}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Popover>
    </>
  );
};

export default CollectionInfoPopover;
